module.exports = __webpack_public_path__ + "img/4.2ac2a06e.jpg";